import Flex from '@/component/atom/Flex';
import { $k18n } from '@/common/i18n';
import { Popup } from '@kibt/meta-ui-krn';
import React from 'react';
import { Text, View, FlatList, ViewStyle } from 'react-native';
import { styles, vh } from '@/common/style';
import { useCoudanInfoStore } from '../coudanInfoStore';
import Radio from '@/component/Radio';
import { LogShow } from '@/component/ViewVisible/ViewVisible';
import ProductCard from '../ProductCard';
import { KView } from '@/component/RtlLayout';
import BottomNodeCom from '../BottomNode';
import { logger } from '@/common/log';
import { useFixedPosition } from '@/hooks/useFixedPosition';
import { onForbidWebDrag } from '@/common/hooks';
import { useUpdateEffect } from 'ahooks';
import { isIOS, isInApp, windowHeight } from '@/common/device-info';
import { allowDefaultOutsideClick, ignoreOutsideClick, onClickContainerOutside } from '@/common/utils/clickOnContinerOutSide';
import { isAndroid } from '@kibt/krn-utils';
import { useABHandler } from '@/page/detail/views/useABHandler';
import { useDetailPageStore } from '@/page/detail/store';
import { useDraggableHeight } from '@/hooks/useDraggableHeight';
import { isFixedViewSupport } from '@/component/FixedView';

const pureStyle = {
    content: {
        backgroundColor: '#fff',
        height: vh(75),
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
    },
};

export function MakeUpPopup(props) {
    const { handleMakeUpItems, beCheck, beUncheck, clickAddtoCar } = props;
    const { detailABValueMap: showDetailCoudan } = useABHandler();

    const pageRawData = useDetailPageStore(s => s.pageRawData);
    const { makeUpPopupVisible, recoItems } = useCoudanInfoStore(s => ({
        makeUpPopupVisible: s.makeUpPopupVisible,
        recoItems: s.recoItems,
    }));

    const setStore = useCoudanInfoStore().setState;

    const changeCheck = (item, checked) => {
        logger.sendClick({
            action: 'BOUGHT_TOGETHER_PRODUCT_CARD',
            params: {
                item_id: item?.itemId,
                seckill_tag: item?.activityInfo?.activityId ? 1 : 0, // 秒杀表示
                product_discount: item?.discountRate, // 商品折扣
                product_type: item?.extra?.productType, //商品类别
                element_type: 1, // 0:商详页凑单楼层模块，1:商详页凑单半屏页
                click_area: 1, // 点击位置。0:商品卡片,1:商品卡片前方勾选按钮,2:规格选项,3:规格数量
            },
        });
        checked ? beCheck(item) : beUncheck(item);
    };
    const divider = <View style={{"marginTop":"2.8985507246376816rem","marginBottom":"3.8647342995169085rem","height":"0.24154589371980678rem","backgroundColor":"rgba(242, 242, 242, 1)"}} />;

    const divider2 = <View style={{"marginTop":"3.8647342995169085rem","marginBottom":"-1.9323671497584543rem","height":"0.24154589371980678rem","backgroundColor":"rgba(242, 242, 242, 1)"}} />;

    useUpdateEffect(() => {
        // 暂时不处理ios的变化，因为ios的isHalfContainerStatus有问题
        if (isInApp && isAndroid) {
            onForbidWebDrag(makeUpPopupVisible);
            if (makeUpPopupVisible) {
                ignoreOutsideClick();
                onClickContainerOutside(() => setStore({ makeUpPopupVisible: false }));
            } else {
                allowDefaultOutsideClick();
            }
        }
    }, [makeUpPopupVisible]);

    const position = useFixedPosition();

    const renderItem = render => {
        const v = render.item;
        const idx = render.index;
        const isLast = idx === recoItems.length - 1;
        return (
            <View key={`${v.itemId}_${v.skuId}`} style={styles({ marginBottom: !isLast ? 16 : 0 })}>
                <Flex flex={'flexRowCenter'}>
                    <Radio
                        style={styles({ height: '100%', paddingRight: 14 })}
                        checked={v?.extra?.selected}
                        disabled={v.disabled || v.skuQuantityLimit === 0}
                        onChecked={checked => {
                            changeCheck(v, checked);
                            if (v.disabled || v.skuQuantityLimit === 0) return;
                        }}
                    />

                    <LogShow
                        action="BOUGHT_TOGETHER_PRODUCT_CARD"
                        params={{
                            item_id: v?.itemId,
                            seckill_tag: v?.activityInfo?.activityId ? 1 : 0, // 秒杀表示
                            product_discount: v?.discountRate, // 商品折扣
                            product_type: v?.extra?.productType, //商品类别
                            element_type: 1, // 0:商详页凑单楼层模块，1:商详页凑单半屏页
                        }}>
                        <ProductCard
                            // style={{"paddingRight":"9.178743961352657rem"}}
                            handleMakeUpItems={handleMakeUpItems}
                            recoItems={recoItems}
                            pruductItem={v}
                            showDetailCoudan={showDetailCoudan}
                        />
                    </LogShow>
                </Flex>
                {idx === 0 ? <View>{divider2}</View> : null}
            </View>
        );
    };
    const containerHeightState = useDraggableHeight();

    return (
        <View style={{}}>
            <Popup
                visible={makeUpPopupVisible}
                maskZindex={200}
                onClose={() => {
                    setStore({ makeUpPopupVisible: false });
                }}
                position="bottom"
                boxStyle={!isFixedViewSupport ? ({ position } as ViewStyle) : {}}>
                <View
                    style={[
                        { ...pureStyle.content, paddingBottom: 10 },
                        isFixedViewSupport && containerHeightState.pageStatus === 'halfScreen'
                            ? {
                                  position: 'relative',
                                  height: containerHeightState.height,
                                  marginBottom: isIOS ? 0 : windowHeight - containerHeightState.height,
                              }
                            : {},
                    ]}>
                    <KView
                        style={styles({
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            marginTop: 12,
                            paddingLeft: 14,
                            paddingRight: 14,
                            justifyContent: 'center',
                        })}>
                        <Text style={[styles({ fontSize: 20, fontWeight: '700', color: '#000' })]}>
                            {$k18n({
                                id: 'k_420452',
                                text: '搭配购',
                            })}
                        </Text>
                    </KView>

                    <View>{divider}</View>

                    <FlatList data={recoItems} renderItem={renderItem} style={{"paddingLeft":"4.5893719806763285rem","paddingRight":"4.5893719806763285rem"}} />

                    <KView rtlClassName={'bottom-btn-content'}>
                        <BottomNodeCom clickAddtoCar={clickAddtoCar} usefulType={'inPopup'} pageRawData={pageRawData} />
                    </KView>
                </View>
            </Popup>
        </View>
    );
}
